const faqItems = [
  {
    q: '国产91视频平台收录了哪些在线视频网站？',
    a: '国产91视频汇集了久久视频、芒果视频、97视频、丝瓜视频、蓝莓视频等主流在线视频资源网站，覆盖视频播放器在线看视频的各类入口，用户可通过本平台快速定位所需视频资源站点。',
  },
  {
    q: '平台上的视频资源更新频率是怎样的？',
    a: '国产91视频每日持续更新视频资源站点入口，确保久久视频、芒果视频等在线视频网站的最新可用链接及时呈现。同时定期巡检已有站点，保证视频播放器在线看视频的稳定性与可用性。',
  },
  {
    q: '如何在移动端使用国产91视频观看在线视频？',
    a: '国产91视频支持移动端浏览器直接访问，页面针对手机和平板设备进行了适配优化。您可在移动入口专区查看适配移动端的视频资源站点推荐，通过视频播放器在线看视频无需额外下载应用。',
  },
  {
    q: '国产91视频需要注册账号才能使用吗？',
    a: '国产91视频为开放式视频资源导航平台，所有久久视频、芒果视频、97视频、丝瓜视频等在线视频网站入口均免费开放浏览，无需注册即可使用全部功能，方便用户快速进入在线看视频体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-12">
          常见问题
        </h2>
        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <details key={i} className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-5 cursor-pointer hover:bg-background-200/50 transition-colors">
                <h3 className="text-base font-semibold text-foreground-800 pr-8">{item.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-lg"></i>
                </span>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}